import { ApolloError, gql, useQuery } from '@apollo/client';
import {
  Payments_GetCollectedManualPaymentsQuery,
  Payments_GetCollectedManualPaymentsQueryVariables,
} from '@/types';

const COLLECTED_MANUAL_PAYMENT_FRAGMENT = gql`
  fragment CollectedManualPaymentFields on CollectedManualPayment {
    collected_date
    credit_memos_count
    invoices_count
    paid_source
    payment_batch {
      restaurant {
        name
        uuid
      }
      uuid
    }
    payment_batch_id
    payment_method_display_text
    total_amount_in_micros
  }
`;

export const GET_COLLECTED_MANUAL_PAYMENTS_QUERY = gql`
  query Payments_GetCollectedManualPayments(
    $employeeUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getCollectedManualPayments(
      employee_id: $employeeUUID
      supplier_id: $supplierUUID
    ) {
      alert_level
      alert_message
      payments {
        ...CollectedManualPaymentFields
      }
    }
  }
  ${COLLECTED_MANUAL_PAYMENT_FRAGMENT}
`;

export const useGetCollectedManualPayments = ({
  employeeUUID,
  onError,
  skip,
  supplierUUID,
}: {
  employeeUUID: string;
  onError?: (error: ApolloError) => void;
  skip?: boolean;
  supplierUUID: string;
}) => {
  return useQuery<
    Payments_GetCollectedManualPaymentsQuery,
    Payments_GetCollectedManualPaymentsQueryVariables
  >(GET_COLLECTED_MANUAL_PAYMENTS_QUERY, {
    fetchPolicy: 'cache-and-network',
    onError,
    skip,
    variables: { employeeUUID, supplierUUID },
  });
};
